import React from 'react';
import clsx from 'clsx';
import {Box, Button, ButtonGroup, Typography, useMediaQuery} from '@material-ui/core';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {makeHighlightStyle} from 'theme';
import stringFromNode from 'helpers/stringFromNode';
import {useConfidenceCheckResponse} from 'data/queries/responses';

const useStyles = makeStyles(theme => {
  const highlightStyle = makeHighlightStyle(theme);
  return {
    card: highlightStyle({
      colors: theme.palette.legacy.actionHighlight.info,
      before: {content: `'\\e3f3 \u00a0 Check in'`}, // healing e3f3
    }),
    prompt: {
      display: 'block',
      marginTop: 2,
      marginBottom: 4,
    },
    group: {
      margin: 'auto',
    },
    button: {
      maxWidth: 300,
      margin: 'auto',
      whiteSpace: 'nowrap',
      '&:disabled': {
        // color: 'rgba(0,0,0,0.8)',
      },
    },
    lowest: {
      color: theme.palette.hint.red.dark,
    },
    low: {
      color: theme.palette.hint.green.dark,
    },
    highest: {
      color: theme.palette.primary.main,
    },
  };
});

const confidences = {
  0: 'lowest',
  1: 'low',
  2: 'highest',
};

const ConfidenceCheck = ({prompt = 'How are you feeling about your progress?'}) => {
  const [value, setValue] = React.useState(null);
  const promptText = stringFromNode(prompt);
  const [_, createResponse] = useConfidenceCheckResponse(promptText);
  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const options = [
    '🙈 \u00a0 Confused \u00a0 🤨',
    '🌱 \u00a0\u00a0 Growing \u00a0\u00a0\u00a0 🙂',
    '🏆 \u00a0 Confident \u00a0 😎',
  ];

  return (
    <Box m={2} mb={10} className={classes.card}>
      <Typography variant="h5">
        <Box pt={2} pb={4} className={classes.prompt}>
          {prompt}
        </Box>
      </Typography>
      <Box maxWidth={600} className={classes.group}>
        <ButtonGroup fullWidth orientation={isMd ? 'horizontal' : 'vertical'}>
          {options.map(
            (option, index) =>
              (!value || value === option) && (
                <Button
                  key={option}
                  disabled={!!value}
                  onClick={() => {
                    setValue(option);
                    createResponse({option, confidence: confidences[index]});
                  }}
                  size="large"
                  className={clsx(classes[confidences[index]], classes.button)}
                >
                  <Typography component="span" variant="body1">
                    <Box>{option}</Box>
                  </Typography>
                </Button>
              )
          )}
        </ButtonGroup>
      </Box>
    </Box>
  );
};

export default ConfidenceCheck;
